const getters = {
  menu: (state) => state.app.menu,
  token: (state) => state.user.token,
  user: (state) => state.user.user,
  unread: (state) => state.user.unread,
  breadcrumb: (state) => state.app.breadcrumb,
  meta: (state) => state.app.meta,
  searchData: (state) => state.post.searchData,
};
export default getters;
